export default __webpack_public_path__ + "1508a1f41cd17adde5e8e2b57ce560e8.svg";